import React from 'react';
import { useTour } from '../contexts/TourContext';
import './TourButton.css';

interface TourButtonProps {

}

const TourButton: React.FC<TourButtonProps> = () => {
  const { startTour } = useTour();

  const handleStartTour = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Find and click the first tab button
    const firstTabButton = document.querySelector('.tab-button:first-child') as HTMLElement;
    if (firstTabButton) {
      firstTabButton.click();
    }

    // Start the tour
    startTour();
  };

  return (
    <button 
      className="tour-button tour-button-component"
      onClick={handleStartTour}
      title="Start the guided tour"
    >
      <span className="tour-button-icon">?</span>
      <span className="tour-button-text">Take Tour</span>
    </button>
  );
};

export default TourButton;